// pt-PT source of truth for the articles area ("Produção Científica").
// English mirrors this exact shape in ../en/articles.ts.
export const articles = {
  title: 'Produção Científica',
  sub: {
    main: 'Artigos do CIIMAR (Scopus)',
    scopusTotal: '{n} no Scopus',
    synced: 'sincronizado {date}',
  },
  source: {
    rest: 'Scopus (Elsevier)',
    stub: 'Não configurado',
    none: 'Sem ligação',
  },
  stub: {
    intro: 'A API Scopus/Elsevier ainda não está configurada neste ambiente. Define a chave',
    and: 'e',
    outro: 'para pescar os artigos.',
  },
  sync: {
    button: 'Sincronizar',
    progress: 'A sincronizar… {done}',
    progressTotal: 'A sincronizar… {done}/{total}',
    failed: 'Sincronização falhou: {error}',
  },
  filters: {
    searchPlaceholder: 'Pesquisar por título, autor, revista ou DOI…',
    allTeams: 'Todas as equipas',
    allResearchers: 'Todos os investigadores',
    allYears: 'Todos os anos',
    allMonths: 'Todos os meses',
    allTypes: 'Todos os tipos',
    allQuartiles: 'Todos os quartis',
    openAccess: 'Acesso aberto',
    cited: 'Com citações',
    clear: 'Limpar',
  },
  loading: 'A carregar…',
  loadingMore: 'A carregar mais…',
  empty: {
    filtered: 'Nenhum artigo corresponde aos filtros.',
    none: 'Sem artigos.',
  },
  count: {
    one: '{n} artigo',
    many: '{n} artigos',
  },
  card: {
    volume: 'vol. {n}',
    ciimarAuthors: 'Investigadores CIIMAR',
    quartileTip: 'Revista no {q}',
    quartileTipPercentile: 'Revista no {q} · percentil CiteScore {p}',
    openAccess: 'Acesso aberto',
    citationsTip: 'Citações (Scopus)',
    citationOne: 'citação',
    citationMany: 'citações',
  },
};
